function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { useRef, useEffect } from 'react';
import { usePropsReactive } from "../utils";
import { allProps, setterMap, converterMap, wrapperStyle, containerStyle, StatusDynamicProps } from "./config";
import { getAMap } from "../utils";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BaseMap = function BaseMap() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mapWrapper = useRef();
  var instanceObj = useRef();
  var _usePropsReactive = usePropsReactive(props, instanceObj, {
      setterMap: setterMap,
      converterMap: converterMap
    }),
    loaded = _usePropsReactive.loaded,
    prevProps = _usePropsReactive.prevProps,
    onInstanceCreated = _usePropsReactive.onInstanceCreated;
  useEffect(function () {
    createInstance().then(function () {
      var _props$onMapCreate;
      (_props$onMapCreate = props.onMapCreate) === null || _props$onMapCreate === void 0 ? void 0 : _props$onMapCreate.call(props, instanceObj.current);
      onInstanceCreated === null || onInstanceCreated === void 0 ? void 0 : onInstanceCreated(instanceObj.current);
    });
  }, []);
  useEffect(function () {
    if (loaded) {
      updateMapProps(prevProps, props);
    }
  }, [props]);

  /** 创建地图实例 */
  var createInstance = function createInstance() {
    var options = buildCreateOptions();
    var AMap = getAMap();
    instanceObj.current = new AMap.Map(mapWrapper.current, options);
    return Promise.resolve();
  };

  /** 获取创建地图的参数 */
  var buildCreateOptions = function buildCreateOptions() {
    var options = {};
    allProps.forEach(function (key) {
      if (key in props) {
        options[key] = getSetterValue(key, props);
      }
    });
    return options;
  };
  var getSetterValue = function getSetterValue(key, props) {
    if (key in converterMap) {
      return converterMap[key](props[key]);
    }
    return props[key];
  };
  var updateMapProps = function updateMapProps(prevProps, nextProps) {
    var nextMapStatus = {};
    var statusChangeFlag = false;
    var statusPropExist = false;
    StatusDynamicProps.forEach(function (key) {
      if (key in nextProps) {
        statusPropExist = true;
        if (detectPropChanged(key, prevProps, nextProps)) {
          statusChangeFlag = true;
          nextMapStatus[key] = nextProps[key];
        }
      }
    });
    statusChangeFlag && instanceObj.current.setStatus(nextMapStatus);
  };
  var detectPropChanged = function detectPropChanged(key, prevProps, nextProps) {
    return prevProps[key] !== nextProps[key];
  };
  return /*#__PURE__*/_jsxs("div", {
    className: props.className,
    style: _objectSpread(_objectSpread({}, wrapperStyle), props.style),
    children: [/*#__PURE__*/_jsx("div", {
      ref: mapWrapper,
      style: containerStyle,
      children: loaded ? null : props.loading
    }), /*#__PURE__*/_jsx("div", {
      children: loaded ? props.children : null
    })]
  });
};